import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../../modules/infra/i18n';
import SimpleCheckbox from '../../../../common/simpleCheckbox';
import Input from '../../../../common/input';

const PromoUsableNumberOfTimes = ({ isUsableNumberOfTimes }) => (
  <div className="layout">
    <div className="layout__item u-nowrap">
      <SimpleCheckbox
        label={t('settings:promo_codes.usage_limit.label')}
        id="isUsableNumberOfTimes"
        name="isUsableNumberOfTimes"
      />
    </div>
    <div className="layout__item u-3/5" display-if={isUsableNumberOfTimes}>
      <div className="o-flexbox o-flexbox--content-align-center">
        <span className="u-fontsize-small">
          {t('settings:promo_codes.usage_limit.text_before')}
        </span>
        <Input type="number" name="usableNumberOfTimes" className="c-input u-width-60" />
        <span className="u-fontsize-small">
          {t('settings:promo_codes.usage_limit.text_after')}
        </span>
      </div>
    </div>
  </div>
);

PromoUsableNumberOfTimes.propTypes = {
  isUsableNumberOfTimes: PropTypes.bool.isRequired,
};

export default PromoUsableNumberOfTimes;
